"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CREDITOR = exports.BANKRUPTCY = exports.CHARITY = exports.PERSONAL = exports.OTHER = exports.SUPPLIERS = exports.LOAN = exports.CREDIT_CARD = exports.AUTOMOBILE = exports.MORTGAGE = void 0; // Creditor

var MORTGAGE = 'mortgage';
exports.MORTGAGE = MORTGAGE;
var AUTOMOBILE = 'automobile';
exports.AUTOMOBILE = AUTOMOBILE;
var CREDIT_CARD = 'credit_card';
exports.CREDIT_CARD = CREDIT_CARD;
var LOAN = 'loan';
exports.LOAN = LOAN;
var SUPPLIERS = 'suppliers';
exports.SUPPLIERS = SUPPLIERS;
var OTHER = 'other'; // Contribution

exports.OTHER = OTHER;
var PERSONAL = 'personal';
exports.PERSONAL = PERSONAL;
var CHARITY = 'charity'; // Consultant

exports.CHARITY = CHARITY;
var BANKRUPTCY = 'bankruptcy';
exports.BANKRUPTCY = BANKRUPTCY;
var CREDITOR = 'creditor';
exports.CREDITOR = CREDITOR;